import { render, staticRenderFns } from "./OutOfStockFeature.vue?vue&type=template&id=7ea3470a&"
import script from "./OutOfStockFeature.vue?vue&type=script&lang=ts&"
export * from "./OutOfStockFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OutOfStockFeature.vue"
export default component.exports